




























import Vue from 'vue';
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import AsiAutocomplete from "../common/AsiAutocomplete";
import {enumTextFromValue} from "@/helpers/functions_asi";
import {CompanyType, UserState} from "@/helpers/constants";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import {Icon} from "@/helpers/icons";
import UserListEntry from "@/models/user/UserListEntry";
import UserListFilter from "@/models/user/UserListFilter";
import CompanySimple from "@/models/company/CompanySimple";

@Component({
	components: {AsiAvatar, AsiAutocomplete}
})
export default class UserAutocompleteInput extends Vue {

	@Prop({default: null})
	public value!: string | string[] | null;

	@Prop({type: Array, default: () => []})
	public users!: UserListEntry[];

	@Prop({type: Object, default: null})
	public userListFilter!: UserListFilter | null;

	@Prop({type: Array, default: () => []})
	public rules!: (string | null | number | object | unknown | boolean)[];

	@Prop({type: Boolean, default: false})
	public clearable!: boolean;

	@Prop({type: Boolean, default: false})
	public disabled!: boolean;

	@Prop({type: Boolean, default: false})
	public multiple!: boolean;

	@Prop({type: String, default: null})
	public label!: string | null;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	@Prop({type: Boolean, default: false})
	public simple!: boolean;

	private loadingInternal: boolean = false;
	private usersInternal: UserListEntry[] = [];
	private icons = Icon;
	private userListFilterInternal: UserListFilter | null = null;

	private get loadingActual(): boolean {
		return this.loading || this.loadingInternal;
	}

	private get finalLabel(): string {
		return this.label !== null ? this.label : this.$t('user.singular').toString();
	}

	public mounted(): void {
		if (this.users.length > 0) {
			this.usersInternal = this.users;
			this.userOptionsChanged();
		} else {
			this.setUserListFilterInternal();
			this.loadUsers();
		}
	}

	@Emit('input')
	public input(event: Event): Event {
		return event;
	}

	@Emit('change')
	public change(event: Event): Event {
		return event;
	}

	@Emit('userOptionsChanged')
	public userOptionsChanged(): UserListEntry[] {
		return this.usersInternal;
	}

	private setUserListFilterInternal(): void {
		this.userListFilterInternal = this.userListFilter ?? new UserListFilter();
		this.userListFilterInternal.states = [UserState.active];
	}

	@Watch('users', {deep: true})
	private onUsersChanged(value: UserListEntry[]): void {
		this.usersInternal = value;
	}

	@Watch('userListFilter', {deep: true})
	private onUserListFilterChanged(): void {
		this.setUserListFilterInternal();
		this.loadUsers();
	}

	private loadUsers(): void {
		this.loadingInternal = true;
		this.$userService.users(this.userListFilterInternal, null)
			.then((data) => {
				this.usersInternal = data.data;
				this.userOptionsChanged();
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.loadingInternal = false;
			})
	}

	private itemText(user: UserListEntry): string {
		return this.userFullName(user) + " (" + user.company.name + " - " + this.companyTypeLabel(user.company) + ")";
	}

	private userFullName(user: UserListEntry): string | null {
		return UserListEntry.fullName(user);
	}

	private companyTypeLabel(company: CompanySimple): string | null {
		return enumTextFromValue(CompanyType, company.type, true);
	}

	private userAvatarUrl(user: UserListEntry): string | null {
		return UserListEntry.avatarUrlSmall(user);
	}

}
